import React from 'react'
import ReactPlayer from 'react-player/youtube'
import { StaticImage } from 'gatsby-plugin-image'

export default function Videos() {
  return (
    <section className="bg-black py-3">
      <div className="w-11/12 mx-auto container py-12 md:py-24">
        <div className="grid grid-col-1 gap-12 max-w-[1000px] mx-auto md:grid-cols-2 ">
          <div className="text-center">
            <StaticImage src="../../../images/logos/bronxnet.png" alt="" />
            <div className="mt-6">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=FdBm256LJOE"
                width="100%"
                height="auto"
                className="rounded [&>iframe]:rounded aspect-video"
                // controls={false}
              />
            </div>
            <p className="text-left mt-3 uppercase">
              BRONXNET INTERVIEWS N'KENGE!
            </p>
          </div>
          <div className="text-center">
            <StaticImage src="../../../images/logos/pix.png" alt="" />
            <div className="mt-6">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=9sczEwkKtwQ"
                width="100%"
                height="auto"
                className="rounded [&>iframe]:rounded aspect-video"
                // controls={false}
              />
            </div>
            <p className="text-left mt-3 uppercase">
              PIX11 interviews N’Kenge!
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
